import React from 'react';

const Checkout = () => {
    return (
        <h1>This is checkout</h1>
    );
};

export default Checkout;